import React, { Component } from 'react'
import { update } from '../utils/apiService'
import { connect } from 'react-redux'
import { toastr } from 'react-redux-toastr'
import { object, func } from 'prop-types'
import { Glyphicon, Tooltip, OverlayTrigger } from 'react-bootstrap'

// actions
import { updateCampaignName } from '../actions'

class CampaignNameEditable extends Component {
  constructor (props) {
    super(props)

    this.state = {
      name: this.props.campaign.name,
      showing: true,
      editing: false,
      saving: false
    }

    this._handleKeyPress = this._handleKeyPress.bind(this)
    this.handleInput = this.handleInput.bind(this)
    this.saveName = this.saveName.bind(this)
  }
  _handleKeyPress (e) {
    if (e.key === 'Enter') {
      this.saveName()
    }
  }
  handleInput (e) {
    this.setState({
      name: e.target.value
    })
  }
  saveName () {
    const { campaign } = this.props
    if (this.state.name === campaign.name) {
      this.setState({
        showing: true,
        editing: false
      })
      return
    }
    this.setState({
      saving: true
    })
    let url = `/campaigns/${campaign.id}`
    let updatedCampaign = Object.assign({}, campaign, { name: this.state.name })
    update(url, { campaign: updatedCampaign })
      .then(res => {
        let newCampaign = res.data
        this.props.updateCampaignName(newCampaign)
        this.setState({
          showing: true,
          saving: false,
          editing: false
        })
        toastr.success('Título atualizado com sucesso!')
      })
      .catch(err => {
        this.setState({
          showing: false,
          editing: true,
          saving: false
        })
        toastr.error('Ocorreu um erro. Tente novamente')
      })
  }
  render () {
    const tooltip = (
      <Tooltip id='tooltip'>Clique para editar</Tooltip>
    )
    return (
      <div>
        {this.state.showing &&
          <OverlayTrigger placement='top' overlay={tooltip}>
            <span
              className='editable'
              onClick={() => {
                let name = this.state.name
                this.setState({ showing: false, editing: true, name: '' },
                  () => this.setState({ name: name }))
              }}>
              {this.state.name} <small className='editable-pencil'><Glyphicon glyph='pencil' /></small>
            </span>
          </OverlayTrigger>
        }
        {this.state.editing &&
          <input
            style={{minWidth: '100%', fontSize: '32px'}}
            className='form-control'
            type='text'
            value={this.state.name}
            onChange={this.handleInput}
            onBlur={this.saveName}
            onKeyPress={this._handleKeyPress}
            disabled={this.state.saving}
            autoFocus
          />
        }
      </div>
    )
  }
}

const mapDispatchToProps = dispatch => {
  return {
    updateCampaignName: campaign => {
      dispatch(updateCampaignName(campaign))
    }
  }
}

CampaignNameEditable.propTypes = {
  campaign: object,
  updateCampaignName: func
}

export default connect(null, mapDispatchToProps)(CampaignNameEditable)



// WEBPACK FOOTER //
// ./src/components/CampaignNameEditable.js